import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import { Track } from 'ngx-audio-player';
import { WploginService } from 'src/app/services/wplogin.service';
import { forEach } from '@angular/router/src/utils/collection';
import { PDFProgressData } from 'ng2-pdf-viewer';



import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from 'src/app/info-dialog/info-dialog.component';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

interface Typs {
  value: string;
  viewValue: string;
}

interface Tests {
  value: string;
  viewValue: string;
}

interface Interviews {
  value: string;
  viewValue: string;
}

export interface Pdf {
  title: string;
  url: string;
}

interface Doc {
  title: string;
}

@Component({
  selector: 'app-doctyp5',
  templateUrl: './doctyp5.component.html',
  styleUrls: ['./doctyp5.component.scss']
})
export class Doctyp5Component implements OnInit {

  today: number = Date.now();

  tests = [];
  testsShort = [];
  interviewSelect = [];
  selectedTest = [];
  selectedInterview = [];

  selectTyps: Typs[] = [
    {value: 'ohne', viewValue: 'Ohne Dateiverweis'},
    {value: 'tests', viewValue: 'Tests'},
    {value: 'interviews', viewValue: 'Interviews'},
  ];


  selectTests: Tests[] = this.tests;
  selectInterviews: Interviews[] = this.interviewSelect;

  selectedTyp = this.selectTyps[0];
  // selectedTest = this.selectTests[0];
  // selectedInterview = this.selectInterviews[0].value;

  @Input() Document: any;
  selectedValue: string;
  pdfs: Pdf[] = [];


  access = false;
  // Material Style Basic Audio Player Title and Audio URL
  selectedRow: Number;
  setClickedRow: Function;


  // Material Style Advance Audio Player Playlist
  msaapPlaylist: Track[] = [];
  waveColor: string;
  waveColorTrans: string;
  dokumentation: any[] = [];
  value = 0;
  abstract: any;
  testlnk: any;
  selected: string;



  constructor(
    private http: HttpService,
    private wplogin: WploginService,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,

  ) {

  }


  showMoreInfos(title, abheft, doi, abstract, link, typ): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: {
        title: title,
        abheftordnung: abheft,
        doi: doi,
        abstract: abstract,
        link: link,
        typ: typ
      }
    });
  }

  ngOnInit() {




    this.access = this.wplogin.getLoginStatus();


    switch (this.Document['5_us_welle']['content']) {
      case '1. Welle':
        this.waveColor = 'rgba(255, 0, 0) ';
        this.waveColorTrans = 'rgba(255, 0, 0, .2) ';
        break;
      case '2. Welle':
        this.waveColor = 'rgba(139, 0, 139) ';
        this.waveColorTrans = 'rgba(139, 0, 139, .2) ';
        break;
      case '3. Welle':
        this.waveColor = 'rgba(255,185,15) ';
        this.waveColorTrans = 'rgba(255,185,15, .2) ';
        break;
      case '4. Welle':
        this.waveColor = 'rgba(0,205,0) ';
        this.waveColorTrans = 'rgba(0,205,0, .2) ';
        break;
      case '5. Welle':
        this.waveColor = 'rgba(121,205,205) ';
        this.waveColorTrans = 'rgba(121,205,205, .2) ';
        break;
      case '6. Welle':
        this.waveColor = 'rgba(0,0,255) ';
        this.waveColorTrans = 'rgba(0,0,255, .2) ';
        break;
      case '7. Welle':
        this.waveColor = 'rgba(240,230,140) ';
        this.waveColorTrans = 'rgba(240,230,140, .2) ';
        break;
      case '8. Welle':
        this.waveColor = 'rgba(255,105,180) ';
        this.waveColorTrans = 'rgba(255,105,180,.2) ';
        break;
      default:
        this.waveColor = 'rgba(102,102,102) ';
        this.waveColorTrans = 'rgba(102,102,102,.2) ';
    }


    if (this.Document['5_Interview']) {
      this.Document['5_Interview'].forEach(element => {
        this.msaapPlaylist.push(
          {
            title: element.iw_dateiname_tondatei,
            link: '/wp-content/themes/graphy/app/assets/anhang/' + this.Document.key + '-kf-' + element.iw_mp3datei + '.mp3'
          },
        );
      });
    }

    if (this.Document['5_Interview']) {
      this.Document['5_Interview'].forEach(element => {
        this.interviewSelect.push(
          {
            value: element.iw_id_ids_mannheim,
            viewValue: element.iw_id_ids_mannheim
          },
        );
      });
    }


    if (this.Document['5_iw_tests']) {
      this.Document['5_iw_tests'].forEach(tests => {
        this.http.analyse(tests['ID']).subscribe(analyse => {
        this.testsShort.push(
            {
              title: tests.content,
              link: analyse['_source'].LmAdd.testlnk
          }
        );
        });

      });
    }



    if (this.Document['5_Dokumentation_Tests']) {
      this.Document['5_Dokumentation_Tests'].forEach(tests => {


        tests.us_testid.forEach(testid => {

          this.http.analyse(testid['ID']).subscribe(analyse => {
            this.tests.push(
              {
                title: testid.content,
                link: analyse['_source'].LmAdd.testlnk,
                viewValue: testid.content,
                value: tests.us_doi_dok
              },
            );
          });
        });
      });
    }

    this.tests.sort(function (a, b) {
      return parseFloat(a.title) - parseFloat(b.title);
    });

    this.tests.sort((a, b) => a.title.localeCompare(b.title));

    console.log(this.tests);
    if (this.Document['5_Dokumentation_Tests']) {
      this.Document['5_Dokumentation_Tests'].forEach(item => {
        if (item['us_interaktionsart']) {
          item['us_interaktionsart'].forEach(value => {
            this.dokumentation.push(
              {
                cat: value.content,
                items: []
              }
            );
          });
        }
      });
    }

    // delete dublicate objects
    this.dokumentation = this.dokumentation.filter((element, index, self) =>
      index === self.findIndex((t) => (
        t.cat === element.cat
      )));

      console.log(this.dokumentation);


    // order each element to cat
    if (this.Document['5_Dokumentation_Tests']) {
      this.Document['5_Dokumentation_Tests'].forEach(item => {
        item.us_interaktionsart.forEach(art => {
          this.dokumentation.forEach(category => {
            if (art.content === category.cat) {

              item.us_testid.forEach(element => {

                this.http.analyse(element['ID']).subscribe(analyse => {

                  this.http.doctyp3(analyse['_source'].LmAdd.testlnk).subscribe(doctyp3 => {

                    if (!doctyp3.error) {
                      if (doctyp3['_source']) {
                        if (doctyp3['_source']['3_pt_abstract']) {
                          this.abstract = doctyp3['_source']['3_pt_abstract'];
                        }
                      }
                    }





                    category.items.push(
                      {
                        title: element.content,
                        abheft: item.us_abheftordnung,
                        doi: item.us_doi_dok,
                        link: analyse['_source'].LmAdd.testlnk,
                        abstract: this.abstract,
                        // tslint:disable-next-line:max-line-length
                        url: 'https://bolsa.uni-halle.de/wp-content/themes/graphy/app/assets/anhang/' + this.Document.key + '-kf-' + item.us_pdfdatei + '.pdf',
                        typ: art.content
                      }
                    );
                  });
                });
              });
            }
          });
        });
      });
    }

    console.log(this.selectedTyp);

    // if (this.selectedTyp  'ohne') {

    // }


}




  onProgress(progressData: PDFProgressData) {
    this.value = Math.floor((progressData.loaded / progressData.total) * 100);
  }


  showPdf(url) {
    this.selectedValue = url;
  }


  link(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + id]));
  }

  copy2Clipboard() {
    const element = document.getElementById('copy-cit');
    console.log(element);
    element.innerHTML = element.innerText || element.textContent;
    const ta = document.createElement('textarea');
    ta.value = element.innerHTML;

    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);

    this.snackBar.open('In die Zwischenablage kopiert', 'schließen', {
      duration: 2000,
    });
  }


}


